import { API_URL } from "@/config.tsx";
import axios from "axios";

/** Запрос на смену товара в корзине */
export const replaceCartElementRequest = async (cartElementId: number) => {
    return await axios.post(`${API_URL}/cart_element/${cartElementId}/replace_item`, {
        withCredentials: true,
    });
};
